import JSZip from 'jszip';

export const extractGlbFromZip = async (zipUrl) => {
    try {
        const response = await fetch(zipUrl);
        if (!response.ok) {
            throw new Error('Failed to fetch ZIP file');
        }
        
        const zipBlob = await response.blob();
        
        const zip = new JSZip();
        let zipContent;
        try {
            zipContent = await zip.loadAsync(zipBlob);
        } catch (zipError) {
            throw new Error('Failed to load ZIP file');
        }
        
        const glbFiles = [];
        
        for (const [filename, file] of Object.entries(zipContent.files)) {
            if (filename.toLowerCase().endsWith('.glb')) {
                glbFiles.push(filename);
            }
        }
        
        if (glbFiles.length === 0) {
            const foundFiles = Object.keys(zipContent.files);
            throw new Error('No GLB files found in ZIP');
        }
        
        const glbFileName = glbFiles[0];
        const glbBlob = await zipContent.file(glbFileName).async('blob');
        
        const glbUrl = URL.createObjectURL(glbBlob);
        
        return {
            glbUrl,
            glbFileName,
            glbBlob
        };
    } catch (error) {
        throw error;
    }
};

export const loadDirectGlbFile = async (glbUrl) => {
    try {
        return {
            glbUrl,
            glbFileName: glbUrl.substring(glbUrl.lastIndexOf('/') + 1),
            glbBlob: null
        };
    } catch (error) {
        throw error;
    }
}; 